import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { LoadContainers_ModuleContextService } from './LoadContainers.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class LoadContainers_container_sizes_ComponentContextService {
  private readonly moduleContext: LoadContainers_ModuleContextService;

  constructor(moduleContext: LoadContainers_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'container_sizes',
      type: ComponentType.selector
    }
  }
}